import qs from "qs";
const toCorrespondingUrl = (url, fullPath, params) => {
    let paramsStr = fullPath.split('?')[1]
    let correspondingUrl = `/pctomobile?fullPath=${encodeURIComponent(fullPath)}`
    // 旧项目PC端路由列表和详情页对应NUXTPC端路由 todo:等将来NUXT项目完善后可删除
    switch (url) {
        case '/zwzx':
            correspondingUrl = '/list/information?id=1'
            break;
        case '/xsjh':
            correspondingUrl = '/list/collect?id=3'
            break;
        case '/bkjx':
            correspondingUrl = '/list/choiceness?id=4'
            break;
        case '/xszs':
            correspondingUrl = '/list/summarize?id=5'
            break;
        case '/xszz':
            correspondingUrl = '/list/monograph?id=6'
            break;
        case '/bjzx':
            correspondingUrl = '/list/scholar?id=8'
            break;
        case '/bkzx':
            correspondingUrl = '/list/periodical?id=9'
            break;
        case '/xshy':
            correspondingUrl = '/list/conference?id=14'
            break;
        case '/search':
            correspondingUrl = `/list/search?key=all&value=${params.paramStr}&changeIdxSearch=0`
            break;
        case '/about':
            correspondingUrl = '/agreement-ABOUT_US'
            break;
        case '/opinion':
            correspondingUrl = '/feedback'
            break;
        case '/bkzxdetail':
            correspondingUrl = `/detail/Periodical?${paramsStr}&item=1`
            break;
        case '/bjzxdetail':
            correspondingUrl = `/detail/scholar?${paramsStr}&item=0`
            break;
        case '/jghdetail':
          correspondingUrl = `/detail/organization?${paramsStr}`
          break;
    }
    // 移动端路由对应NUXTPC端路由
    switch (url) {
        case '/index':
        case '/':
            correspondingUrl = ''
            break;
        case '/academicInformation':
            correspondingUrl = '/list/information'
            break;
        case '/academicPaper':
            correspondingUrl = '/list/collect'
            break;
        case '/academicMonograph':
            correspondingUrl = '/list/monograph'
            break;
        case '/scholarOnline':
            correspondingUrl = '/list/scholar'
            break;
        case '/periodicalOnline':
            correspondingUrl = '/list/periodical'
            break;
        case '/academicConference':
        case '/attendConference':
            correspondingUrl = '/list/conference'
            break;
        case '/bookMall':
            correspondingUrl = '/list/books'
            break;
        case '/searchResult':
            correspondingUrl = `/list/search?key=all&value=${params.paramStr}&changeIdxSearch=0`
            break;
        case '/msgDetails':
            correspondingUrl = `/detail/information?${paramsStr}`
            break;
        case '/thesisDetail':
            correspondingUrl = `/thesisDetail?${paramsStr}`
            break;
        case '/concentrationDetails':
            correspondingUrl = `/detail/monograph?${paramsStr}`
            break;
        case '/bookDetails':
            correspondingUrl = `/detail/books?${paramsStr}`
            break;
        case '/apptcp':
            correspondingUrl = '/agreement-USE_PROTOCOL'
            break;
        case '/mPAgreement':
            correspondingUrl = '/agreement-PRIVACY'
            break;
        case '/appusesbaike':
            correspondingUrl = `/detail/Periodical?${paramsStr}`
            break;
        case '/appusesbaijia':
            correspondingUrl = `/detail/scholar?${paramsStr}`
            break;
        case '/appusesjigou':
          correspondingUrl = `/detail/organization?${paramsStr}`
          break;
        case '/detail/report':
          correspondingUrl = `/detail/report?${paramsStr}`
          break;
        case '/industryReport':
          correspondingUrl = `/list/winShareData?id=7`
          break;
        case '/courseDetails':
          correspondingUrl = `/detail/education?${paramsStr}`
          break;
        case '/appusesinstitutions':
          let queryObj = qs.parse(paramsStr)
          correspondingUrl = `/detail/directoriesInfo?id=${queryObj.orgId}`
          break
    }
    console.log(correspondingUrl, 'correspondingUrl');
    return correspondingUrl
}

export { toCorrespondingUrl }